/**
 * Slugifies a given string.
 *
 * - Lowercase
 * - Remove leading and trailing whitespace
 * - Replace spaces with a hyphen (-)
 * - Remove characters that are not alphanumeric or hyphens
 *
 * @param slug the string to slugify
 * @returns the slugified version of `slug`
 */
export default function slugify(slug: string | undefined): string {
    // needs to be explicit, otherwise it will catch empty strings
    if (typeof slug !== 'string') return 'undefined';
    return slug
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^A-Za-z0-9-]/g, '');
}
